<script setup lang='ts'>
import { useI18n } from 'vue-i18n';

import useBookingOpening from '@/composables/useBookingOpening';

const { t } = useI18n();
const { formattedOpeningDate, formattedOpeningTime } = useBookingOpening();
</script>

<template>
  <p class="booking-opening-message">
    {{ t('booking.openingSoon', { date: formattedOpeningDate, time: formattedOpeningTime }) }}
  </p>
</template>

<style scoped lang="css">
.booking-opening-message {
  background-color: #fefce8;
  border-radius: 4px;
  padding: 2rem;
  text-align: center;
  font-weight: 600;
}
</style>
